module.exports = __webpack_public_path__ + "static/media/swiss_timing_logo.8f50fd5c.png";